/* eslint-disable no-case-declarations */


/* eslint-disable eqeqeq */
export const types = {
    POST: 'CREATE_FORM',
    PUT: 'UPDATE_FORM',
    DELETE: 'DELETE_FORM',
    RESET: 'RESET_FORM',
    RELOAD: 'RELOAD_FORM',
    UPDATE_ITEM: 'UPDATE_LOCAL_FORM',
  };
  
  export const getDraftId = () => `form-${Date.now()}`;
 
  export const camerasPresentationReducer = (state = {}, action) => {


    switch (action.type) {
      
      
      case types.PUT:
        
        const editFormValues = { ...action.payload };
        // console.log("editarValores",editFormValues)
        return editFormValues;
      case types.UPDATE_ITEM:
        
        const updateFormValues = { ...action.payload };
        // console.log("updateValores",updateFormValues)
        return updateFormValues;
      default:
        return state;
    }
  };
  